<template>
    <div>
        <Navbar />
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-9">
                    <BetslipButton v-if="$store.state.isMobileScreen" />
                    <router-view />
                </div>
                <div class="col-12 col-md-3">
                    <RightBar />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Navbar from "@/components/navbar/navbar.vue";
import BetslipButton from "@/components/common/betslip-button.vue"
import RightBar from "@/components/right-bar/right-bar.vue"
export default {
    components: { Navbar, BetslipButton, RightBar }
}
</script>